module.exports = __webpack_public_path__ + "img/cover.ccd80900.png";